import { TechnicalSupportContentModel } from '../generated/types/TechnicalSupportContentModel';

const defaultTechnicalSupportContentMock: TechnicalSupportContentModel = {
  _content_type_uid: 'technical_support',
  client_application: { client_value: ['hcp-web'] },
  title: 'Technical Support',
  email: 'support@unifytrialspro.com',
  contact_details: [
    {
      title: 'Sweden',
      country: { country: ['SE'] },
      phone_number: '+461234567',
      email: 'support_sweden@unifytrialspro.com',
    },
  ],
  uid: '',
  metadata: {},
};

const create = (partial?: Partial<TechnicalSupportContentModel>): TechnicalSupportContentModel => ({
  ...defaultTechnicalSupportContentMock,
  ...partial,
});

export const TechnicalSupportContentModelMock = { create };
